/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-10-27 11:24:13
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2023-02-01 17:02:23
 * @FilePath     : /ticket-plat-frontend/src/common/monitor.ts
 */
import Vue from 'vue';
import Config, {ENV} from '@/config';

// 添加监控
const Weirwood = require('@baidu/weirwood-sdk');
const WeirwoodOptions = require('../../weirwood.json');
const options = {
    common: {
        // 只支持如下字符：英文字母(大小写)，数字(0-9)，下划线(_)，中划线(-)，点(.)，@符号
        buildid: WeirwoodOptions.buildid || 'localhost',
        token: WeirwoodOptions.token,
        ignoreUrls: [
            // 本地开发屏蔽错误发送，请按需修改
            'localhost',
            '127.0.0.1',
            'ticket.bcetest.baidu.com', // 沙盒
            'ticket-preonline.bce.baidu.com', // 预生产
            'qasandbox.bcetest.baidu.com',
            // 'console.bce.baidu.com/ticket/pre-online',
        ],
    },
    // 配置见：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/gv0WKdV3ZF/60incnF1Zd/kGVSEPWrQ8QLET
    error: {
        behaviorOptions: {
            dom: false,
            fetch: false,
            history: false,
            weirwood: false,
            xhr: false,
        },
        collectAutoAPIException: false,
        allowDuplicates: false,
        collectWindowErrors: true,
        collectUnhandledRejections: false,
        collectResourceLoadErrors: true, // 静态资源加载异常
        // 资源加载异常白名单列表
        resourceWhitelistUrls: [
            'console.bce.baidu.com',
            'bce.bdstatic.com/console/static/ticket',
        ],
    },
    // 配置见：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/gv0WKdV3ZF/60incnF1Zd/Okl-Fk37Er01TM
    perf: {
        sampleRate: 1,
        spa: true,
        history: false,
    },
};

const initMonitor = () => {
    const weirwood = Weirwood.init(options);
    // 核心：Hook Vue 的错误方法，调用 'weirwood' 的 'captureException' 方法
    if (ENV !== 'sandbox') {
        Vue.config.errorHandler = function (err) {
            // 需要自己主动抛出错误，否则你将无法在console中看见报错
            console.error(err);
            weirwood.error.captureException(err);
        };
    }
};

const origin = window.location.origin;
if (origin === Config.CONSOLE_HOST) {
    console.log('init monitor');
    initMonitor();
}
